<script>
import {mapState, mapActions} from 'vuex';
import CalendarElement from '../ManageAllocationCalendarElement/ManageAllocationCalendarElement.vue';
import moment from 'moment';

export default {
    components: {
        CalendarElement
    },
    computed: {
        ...mapState({
            infoPage: state => state.allocation.calendar.infoPage
        }),
        defaultDate: {
            get() {
                return moment().startOf('day');
            }
        }
    },
    methods: {
        ...mapActions({
            infoPageSet: 'allocation/infoPageSet'
        })
    }
}
</script>

<template>
    <transition name="slide-in">
        <div :key="2" class="manage-allocation-calendar-infobox-pages">
            <div class="manage-allocation-calendar-infobox-pages__body">
                <div v-if="infoPage === 1" class="manage-allocation-calendar-infobox-pages__page">
                    <div class="manage-allocation-calendar-infobox-pages__content">
                        <div id="img-1"><img src="../../assets/img/calendar-info/green.jpg" height="450" width="240"></div>
                        <div id="img-2"><img src="../../assets/img/calendar-info/yellow.jpg" height="450" width="240"></div>
                        <div id="img-3"><img src="../../assets/img/calendar-info/red.jpg" height="450" width="240"></div>
                    </div>
                </div>
                <div v-if="infoPage === 2" class="manage-allocation-calendar-infobox-pages__page">
                    <div class="manage-allocation-calendar-infobox-pages__content">
                        <div id="img-5"><img src="../../assets/img/calendar-info/select.jpg" height="450" width="240"></div>
                        <div id="img-4"><img src="../../assets/img/calendar-info/modal.jpg" height="450" width="240"></div>
                        <div id="img-6"><img src="../../assets/img/calendar-info/added.jpg" height="450" width="240"></div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationCalendarInfoboxPages/ManageAllocationCalendarInfoboxPages.vue